import {
  toPathReferenceTrn,
  type MissionPathRef,
} from './map-mission-path-reference';

export function draftHasPath(
  draft: ReadonlySet<string>,
  pathRef: string,
  missions: readonly MissionPathRef[]
): boolean {
  for (const stored of draft) {
    if (toPathReferenceTrn(stored, missions) === pathRef) {
      return true;
    }
  }
  return false;
}

export function draftWithoutPath(
  draft: ReadonlySet<string>,
  pathRef: string,
  missions: readonly MissionPathRef[]
): Set<string> {
  const next = new Set<string>();
  for (const stored of draft) {
    if (toPathReferenceTrn(stored, missions) !== pathRef) {
      next.add(stored);
    }
  }
  return next;
}
